import {Injectable} from '@angular/core';
import {RPriceInfoModel} from '../models/r-price-info.model';
import {MyProductRPricesSelectBaseEnum} from '../enums/my-product-rprices-select-base.enum';
import {EnumUtils} from '../utils/enum.utils';
import {PriceInfoModel} from '../models/price-info.model';
import {MyPageRPricesSelectBase} from '../enums/my-page-rprices-select-base.enum';
import {DecimalPipe} from '@angular/common';

@Injectable()
export class EditModalCustomPriceTableService {

    constructor() {
    }

    public getExtendedRPriceChoices(priceInfos: RPriceInfoModel[]): string[] {
        if (priceInfos && priceInfos.length > 0 && priceInfos[0].rPrice !== undefined) {

            const priceChoices = priceInfos.map(priceInfo => {
                const formattedRPrice = new DecimalPipe('de-DE').transform(+priceInfo.rPrice, '1.2-2');
                return formattedRPrice + ' € (' + priceInfo.rPriceIdentifier + ')'
            });
            return [...priceChoices, MyProductRPricesSelectBaseEnum.CUSTOM];
        }
        return [MyProductRPricesSelectBaseEnum.CUSTOM];
    }


    public getExtendedRPriceValues(priceInfos: RPriceInfoModel[]): string[] {
        if (priceInfos?.[0].rPriceIdentifier !== undefined) {
            const priceValues = priceInfos.map(priceInfo => priceInfo.rPriceIdentifier);
            return [
                ...priceValues,
                EnumUtils.getKeyByValue(MyProductRPricesSelectBaseEnum, MyProductRPricesSelectBaseEnum.CUSTOM)
            ];
        }
        return [EnumUtils.getKeyByValue(MyProductRPricesSelectBaseEnum, MyProductRPricesSelectBaseEnum.CUSTOM)];
    }

    public getExtendedPagePriceChoices(priceInfos: RPriceInfoModel[]): string[] {
        const result = Object.assign([], priceInfos).map(priceInfo => priceInfo.rPrice + ' €');
        result.push(MyPageRPricesSelectBase.CUSTOM);
        return result;


    }

    public getExtendedPagePriceValues(priceInfos: RPriceInfoModel[]): string[] {
        const result = Object.assign([], priceInfos).map(priceInfo => priceInfo.rPriceIdentifier);
        result.push(EnumUtils.getKeyByValue(MyPageRPricesSelectBase, MyPageRPricesSelectBase.CUSTOM));
        return result;
    }


    public onPriceTypeChanged(priceInfo: PriceInfoModel) {
        // if (MyProductRPricesSelectBaseEnum[priceInfo.selectedPrice] !== MyProductRPricesSelectBaseEnum.CUSTOM) {
        //
        //     if (priceInfo.customPriceInfo && priceInfo.customPriceInfo.customPriceComment) {
        //         console.log(
        //             priceInfo.selectedPrice + ' -  price note was removed ... removed value: ',
        //             priceInfo.customPriceInfo.customPriceComment
        //         );
        //     }
        //
        //     priceInfo.customPriceInfo = new CustomPriceInfoModel();
        // }
    }

    public isSelectedPriceTypeEqualOtherPrice(priceType: string) {
        return MyProductRPricesSelectBaseEnum[priceType] === MyProductRPricesSelectBaseEnum.CUSTOM;
    }

    public priceNoteShouldBeVisible(priceType: string) {
        return MyProductRPricesSelectBaseEnum[priceType] === MyProductRPricesSelectBaseEnum.CUSTOM;
    }
}
